import React from 'react';

import { Card, CardBody, CardTitle, Row } from 'reactstrap';

import Spin from 'antd/lib/spin';
import 'antd/lib/spin/style/index.css';
import { LoadingOutlined } from '@ant-design/icons';

import { createUseStyles } from 'react-jss';

import { useHostSingleMetrics } from '../../utils/queries/hostQueries';
import { get, toNumber } from 'lodash-es';

const useStyles = createUseStyles({
  header: {
    paddingTop: (props) => props.paddingTop || '5.4rem',
    paddingBottom: (props) => props.paddingBottom || '7.3rem',
    marginTop: (props) => props.marginTop || '0rem',
  },
  antSpinner: {
    color: 'black',
    '& .ant-spin-dot-item': {
      backgroundColor: '#2675b8',
    },
  },
});

const Header = ({ displayHostLabel, ...props }) => {
  const classes = useStyles(props);
  const { data, isLoading, error } = useHostSingleMetrics();

  return (
    <>
      <div className={classes.header} /* className="pb-8 pt-md-7 mt-1" */>
        <div
          className="header-body"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            paddingLeft: '29px',
            paddingRight: '29px',
            paddingTop: '5px',
            paddingBottom: '5px',
          }}
        >
          {/* Card stats */}

          <Card
            className="card-stats"
            style={{
              border: '1px solid #dedee1',
              borderRadius: '10px',
              /* boxShadow: '0 0 2rem 0 rgb(136 152 170 / 15%)', */
              margin: '10px',
              flexGrow: 1,
            }}
          >
            <CardBody>
              <Row>
                <div
                  className="col"
                  style={{
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <CardTitle
                    tag="h5"
                    className="text-uppercase text-muted text-center mb-0"
                  >
                    No. of Chargers
                  </CardTitle>
                  <span
                    className="h1 font-weight-bold text-center mb-0"
                    style={{ fontSize: '30px' }}
                  >
                    {isLoading ? (
                      <Spin
                        spinning={isLoading}
                        size="large"
                        className={classes.antSpinner}
                        indicator={
                          <LoadingOutlined
                            style={{ color: '#2675b8', fontSize: 17 }}
                          />
                        }
                      />
                    ) : error ? (
                      'Error occured'
                    ) : (
                      get(data, 'TOTAL_CHARGERS', 0) || 0
                    )}
                  </span>
                </div>
              </Row>
              {/* <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-success mr-2">
                        <i className="fa fa-arrow-up" /> 3.48%
                      </span>{' '}
                      <span className="text-nowrap">Since last month</span>
                    </p> */}
            </CardBody>
          </Card>

          <Card
            className="card-stats"
            style={{
              border: '1px solid #dedee1',
              borderRadius: '10px',
              margin: '10px',
              flexGrow: 1,
            }}
          >
            <CardBody>
              <Row>
                <div
                  className="col"
                  style={{
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <CardTitle
                    tag="h5"
                    className="text-uppercase text-muted text-center mb-0"
                  >
                    Chargers Online
                  </CardTitle>
                  <span
                    className="h1 font-weight-bold text-center mb-0"
                    style={{ fontSize: '30px', color: '#28a745' }}
                  >
                    {isLoading ? (
                      <Spin
                        spinning={isLoading}
                        size="large"
                        className={classes.antSpinner}
                        indicator={
                          <LoadingOutlined
                            style={{ color: '#2675b8', fontSize: 17 }}
                          />
                        }
                      />
                    ) : error ? (
                      'Error occured'
                    ) : (
                      get(data, 'ONLINE_CHARGERS', 0) || 0
                    )}
                  </span>
                </div>
              </Row>
              {/* <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-danger mr-2">
                        <i className="fas fa-arrow-down" /> 3.48%
                      </span>{' '}
                      <span className="text-nowrap">Since last week</span>
                    </p> */}
            </CardBody>
          </Card>

          <Card
            className="card-stats"
            style={{
              border: '1px solid #dedee1',
              borderRadius: '10px',
              margin: '10px',
              flexGrow: 1,
            }}
          >
            <CardBody>
              <Row>
                <div
                  className="col"
                  style={{
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <CardTitle
                    tag="h5"
                    className="text-uppercase text-muted text-center mb-0"
                  >
                    Charging Sessions
                  </CardTitle>
                  <span
                    className="h1 font-weight-bold text-center mb-0"
                    style={{ fontSize: '30px' }}
                  >
                    {isLoading ? (
                      <Spin
                        spinning={isLoading}
                        size="large"
                        className={classes.antSpinner}
                        indicator={
                          <LoadingOutlined
                            style={{ color: '#2675b8', fontSize: 17 }}
                          />
                        }
                      />
                    ) : error ? (
                      'Error occured'
                    ) : (
                      get(data, 'TOTAL_SESSIONS', 0) || 0
                    )}
                  </span>
                </div>
              </Row>
              {/* <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-warning mr-2">
                        <i className="fas fa-arrow-down" /> 1.10%
                      </span>{' '}
                      <span className="text-nowrap">Since yesterday</span>
                    </p> */}
            </CardBody>
          </Card>

          <Card
            className="card-stats"
            style={{
              border: '1px solid #dedee1',
              borderRadius: '10px',
              margin: '10px',
              flexGrow: 1,
            }}
          >
            <CardBody>
              <Row>
                <div
                  className="col"
                  style={{
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <CardTitle
                    tag="h5"
                    className="text-uppercase text-muted text-center mb-0"
                  >
                    Net Revenue
                    {displayHostLabel ? (
                      <span style={{ fontSize: '10px', color: '#8898aa' }}>
                        {' '}
                        (Commission earned)
                      </span>
                    ) : null}
                  </CardTitle>
                  <span
                    className="h1 font-weight-bold text-center mb-0"
                    style={{ fontSize: '30px' }}
                  >
                    <span style={{ fontSize: '18px' }}>₹</span>{' '}
                    {isLoading ? (
                      <Spin
                        spinning={isLoading}
                        size="large"
                        className={classes.antSpinner}
                        indicator={
                          <LoadingOutlined
                            style={{ color: '#2675b8', fontSize: 17 }}
                          />
                        }
                      />
                    ) : error ? (
                      'Error occured'
                    ) : (
                      (toNumber(get(data, 'TOTAL_REVINUE', 0)) / 100).toFixed(
                        0,
                      ) || 0
                    )}
                  </span>
                  {/* <div className="text-center mb-0">
                    {displayHostLabel ? (
                      <span style={{ fontSize: '10px', color: '#8898aa' }}>
                        {' '}
                        (without GST)
                      </span>
                    ) : null}
                  </div> */}
                </div>
              </Row>
              {/* <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-warning mr-2">
                        <i className="fas fa-arrow-down" /> 1.10%
                      </span>{' '}
                      <span className="text-nowrap">Since yesterday</span>
                    </p> */}
            </CardBody>
          </Card>

          <Card
            className="card-stats"
            style={{
              border: '1px solid #dedee1',
              borderRadius: '10px',
              margin: '10px',
              flexGrow: 1,
            }}
          >
            <CardBody>
              <Row>
                <div
                  className="col"
                  style={{
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <CardTitle
                    tag="h5"
                    className="text-uppercase text-muted text-center mb-0"
                  >
                    Energy Sold
                  </CardTitle>
                  <span
                    className="h1 font-weight-bold text-center mb-0"
                    style={{ fontSize: '30px' }}
                  >
                    {isLoading ? (
                      <Spin
                        spinning={isLoading}
                        size="large"
                        className={classes.antSpinner}
                        indicator={
                          <LoadingOutlined
                            style={{ color: '#2675b8', fontSize: 17 }}
                          />
                        }
                      />
                    ) : error ? (
                      'Error occured'
                    ) : (
                      toNumber(get(data, 'TOTAL_KWH', 0)).toFixed(2) || 0
                    )}{' '}
                    <span style={{ fontSize: '12px' }}>kWh</span>
                  </span>
                </div>
              </Row>
              {/* <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-success mr-2">
                        <i className="fas fa-arrow-up" /> 12%
                      </span>{' '}
                      <span className="text-nowrap">Since last month</span>
                    </p> */}
            </CardBody>
          </Card>

          <Card
            className="card-stats"
            style={{
              border: '1px solid #dedee1',
              borderRadius: '10px',
              margin: '10px',
              flexGrow: 1,
            }}
          >
            <CardBody>
              <Row>
                <div
                  className="col"
                  style={{
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <CardTitle
                    tag="h5"
                    className="text-uppercase text-muted text-center mb-0"
                  >
                    Active Sessions
                  </CardTitle>
                  <span
                    className="h1 font-weight-bold text-center mb-0"
                    style={{ fontSize: '30px', color: '#2675b8' }}
                  >
                    {isLoading ? (
                      <Spin
                        spinning={isLoading}
                        size="large"
                        className={classes.antSpinner}
                        indicator={
                          <LoadingOutlined
                            style={{ color: '#2675b8', fontSize: 17 }}
                          />
                        }
                      />
                    ) : error ? (
                      'Error occured'
                    ) : (
                      get(data, 'ACTIVE_SESSION', 0) || 0
                    )}
                  </span>
                </div>
              </Row>
              {/* <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-success mr-2">
                        <i className="fas fa-arrow-up" /> 12%
                      </span>{' '}
                      <span className="text-nowrap">Since last month</span>
                    </p> */}
            </CardBody>
          </Card>

          <Card
            className="card-stats "
            style={{
              border: '1px solid #dedee1',
              borderRadius: '10px',
              margin: '10px',
              flexGrow: 1,
            }}
          >
            <CardBody>
              <Row>
                <div
                  className="col"
                  style={{
                    justifyContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <CardTitle
                    tag="h5"
                    className="text-uppercase text-muted text-center mb-0"
                  >
                    Chargers Offline
                  </CardTitle>
                  <span
                    className="h1 font-weight-bold text-center mb-0"
                    style={{ fontSize: '30px', color: '#e61b1b' }}
                  >
                    {isLoading ? (
                      <Spin
                        spinning={isLoading}
                        size="large"
                        className={classes.antSpinner}
                        indicator={
                          <LoadingOutlined
                            style={{ color: '#2675b8', fontSize: 17 }}
                          />
                        }
                      />
                    ) : error ? (
                      'Error occured'
                    ) : (
                      get(data, 'TOTAL_CHARGERS', 0) -
                        get(data, 'ONLINE_CHARGERS', 0) || 0
                    )}
                  </span>
                </div>
              </Row>
              {/* <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-danger mr-2">
                        <i className="fas fa-arrow-down" /> 3.48%
                      </span>{' '}
                      <span className="text-nowrap">Since last week</span>
                    </p> */}
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
};

export default Header;
